import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../components/vendorWebFolder/helperFunctions/axiosInstance";

// Asyn thunk to get all cluster accepted by vendor for payment table.
export const acceptedClusterByVendor = createAsyncThunk(
  "vendorPayment/allClusterAcceptedByVendor",
  async (
    { vendorId, page, limit, searchProduct = "", paymentStatus = "" },
    thunkAPI
  ) => {
    try {
      const response = await axiosInstance.get(
        `/vendorClusterBatches/acceptedClustersByVendorForWeb?vendorIdFromWeb=${vendorId}&page=${page}&limit=${limit}&searchProduct=${searchProduct}&paymentStatus=${paymentStatus}`
      );
      return {
        clusters: response?.data.data,
        totalCount: response?.data.totalCount,
      };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

// Asyn thunk for the vendor payment main dashboard data.
export const mainDashboardOfPayment = createAsyncThunk(
  "vendorPayment/mainPaymentDashboard",
  async (vendorId, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        `/vendorPayment/mainPaymentDashboard?vendorId=${vendorId}`
      );
      return response?.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

// Asyn thunk for the Individual cluster payment data.
export const fetchIndividualClusterPayment = createAsyncThunk(
  "vendorPayment/individualClusterPayment",
  async ({ vendorId, clusterId }, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        `/vendorPayment/allPaymentsOfIndividualCluster?vendorId=${vendorId}&clusterId=${clusterId}`
      );
      return response?.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

const vendorPaymentSlice = createSlice({
  name: "vendorPayment",
  initialState: {
    clustersAcceptedByVendor: [],
    totalClustersCount: 0, // <-- NEW
    mainDashboardOfPayment: [],
    individualClusterPaymentData: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // accepted clusters with pagination
      .addCase(acceptedClusterByVendor.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(acceptedClusterByVendor.fulfilled, (state, action) => {
        state.loading = false;
        state.clustersAcceptedByVendor = action.payload.clusters;
        state.totalClustersCount = action.payload.totalCount || 0; // <-- NEW
      })
      .addCase(acceptedClusterByVendor.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // main dashboard
      .addCase(mainDashboardOfPayment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(mainDashboardOfPayment.fulfilled, (state, action) => {
        state.loading = false;
        state.mainDashboardOfPayment = action.payload;
      })
      .addCase(mainDashboardOfPayment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // individual cluster
      .addCase(fetchIndividualClusterPayment.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchIndividualClusterPayment.fulfilled, (state, action) => {
        state.loading = false;
        state.individualClusterPaymentData = action.payload;
      })
      .addCase(fetchIndividualClusterPayment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default vendorPaymentSlice.reducer;
